import { defineAbProductSummaryElement } from './scripts/components/ab-product-summary/abProductSummary.element';
import { defineAbProductAffiliateBoxElement } from './scripts/components/ab-product-affiliate-box/abProductAffiliateBox.element';
import { defineAbBuyingGuideElement } from './scripts/components/ab-buying-guide/abBuyingGuide.element';
import "./style/index.scss";
import {defineAbStarsElement} from "@/scripts/components/ab-stars/abStars.element";
import {defineReviewListElement} from "@/scripts/components/review-list/reviewList.element";
import {defineReviewFormElement} from "@/scripts/components/review-form/reviewForm.element";
import {defineAbProgressBarElement} from "@/scripts/components/ab-progress-bar/abProgressBar.element";
import {defineAbTabsElement} from "@/scripts/components/ab-tabs/abTabs.element";
import {defineAbLensCompatibilityElement} from "@/scripts/components/ab-lens-compatibility/abLensCompatibility.element";
import {defineAbLoaderElement} from "@/scripts/components/ab-loader/abLoader.element";
import {defineAbModalElement} from "@/scripts/modules/ab-modal/component/abModal.element";
import {defineAbDataSheetElement} from "./scripts/components/ab-data-sheet/abDataSheet.element";
import {defineAbSelectElement} from "@/scripts/components/ab-select/ab-select.element";
import {AbDataSheetInModalClass} from "@/scripts/components/ab-data-sheet/ab-data-sheet-in-modal.class";
import {AbLensCompatibilityInModal} from "@/scripts/components/ab-lens-compatibility/abLensCompatibilityInModal.class";
import {AbLightbox} from "@/scripts/components/ab-lightbox/ab-lightbox.class";
import {defineAbPictureSetsElement} from "@/scripts/components/ab-picture-sets/ab-picture-sets.element";
import {defineAbSwiperElement} from "@/scripts/components/ab-swiper/abSwiper.element";
import {defineAbProductsElement} from "@/scripts/components/ab-products/abProducts.element";
import {defineAbPc1Element} from "@/scripts/components/ab-pc-1/abPc1.element";
import {defineAbPostCardElement} from "@/scripts/components/ab-post-card/abPostCard.element";
import {defineAbPrettyScrollerElement} from "@/scripts/components/ab-pretty-scroller/abPrettyScroller.element";
import {defineAbSpecificationPickerElement} from "@/scripts/components/ab-specification-picker/abSpecificationPicker.element";
import {defineAbStickyTocElement} from "@/scripts/components/ab-sticky-toc/abStickyToc.element";
import spriteUrl from "./assets/svg-icons/svg.sprite.svg?url";
import { createDomElementHandler } from "./scripts/utils/dom.utils";

defineAbSelectElement();
defineAbStarsElement();
defineReviewListElement();
defineReviewFormElement();
defineAbProgressBarElement();
defineAbTabsElement();
defineAbLensCompatibilityElement();
defineAbModalElement();
defineAbLoaderElement();
defineAbDataSheetElement();
defineAbPictureSetsElement();
defineAbPc1Element();
defineAbPostCardElement();
defineAbProductsElement();
defineAbPrettyScrollerElement();
defineAbSwiperElement();
defineAbSpecificationPickerElement();
defineAbStickyTocElement();
defineAbProductSummaryElement();
defineAbProductAffiliateBoxElement();
defineAbBuyingGuideElement();

checkHotLinks();
AbLightbox.init();


// SvgSprite inject
 ( async () => {
    const res = await fetch(spriteUrl);
    if (!res.ok) throw new Error(`Failed to load SVG sprite: ${res.status}`);
    const svgText = await res.text();
    const wrapper =  createDomElementHandler('div', [], { style: "display: none;"}, svgText );
    document.body.prepend(wrapper);
 })();

// Gestione Hot Links
function checkHotLinks() {
  document.addEventListener('click', (event) => {
    const clickedElement = event.target as HTMLElement;
    if(!clickedElement) return;
    // Other Hot Links
    const abhl = clickedElement.closest("a")?.getAttribute("ab-hot-link");
    const options = clickedElement.closest("a")?.getAttribute("ab-hot-link-options");
    if(!abhl?.length) return;
    switch (abhl) {
      case 'open-data-sheet':
        event.preventDefault();
        const optionsObj = options ? JSON.parse(options) : {};
        new AbDataSheetInModalClass(optionsObj);
        break;
      case 'open-lens-compatibility':
        event.preventDefault();
        const productid = options ? JSON.parse(options).productid : null;
        new AbLensCompatibilityInModal({productid})
    }
  });
}
